import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';

const SOCIAL = {
  facebook: process.env.REACT_APP_FACEBOOK_URL || 'https://facebook.com/getbenefitsavings',
  instagram: process.env.REACT_APP_INSTAGRAM_URL || 'https://instagram.com/getbenefitsavings',
  twitter: process.env.REACT_APP_TWITTER_URL || 'https://x.com/getbenefitsavings',
  linkedin: process.env.REACT_APP_LINKEDIN_URL || 'https://linkedin.com/company/getbenefitsavings',
};

export default function SiteFooter() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo column */}
          <div>
            <div className="flex items-center gap-3 mb-2">
              <img src="/logo.png" alt="GetBenefitSavings" className="h-12 w-auto" />
              <h3 className="text-white font-bold text-xl">GetBenefitSavings</h3>
            </div>
            <p className="text-sm mb-3">Smart benefits management for modern employees.</p>
            <div className="flex items-center gap-3">
              <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-400 hover:text-white transition-colors"><Facebook size={16} /></a>
              <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-400 hover:text-white transition-colors"><Instagram size={16} /></a>
              <a href={SOCIAL.twitter} target="_blank" rel="noopener noreferrer" aria-label="X" className="text-gray-400 hover:text-white transition-colors"><Twitter size={16} /></a>
              <a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-400 hover:text-white transition-colors"><Linkedin size={16} /></a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Navigate</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/articles" className="hover:text-white transition-colors">Articles</Link></li>
              <li><Link to="/getstarted" className="hover:text-white transition-colors">Get Started</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/news" className="hover:text-white transition-colors">News</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 text-center text-sm">
          <p>&copy; 2026 GetBenefitSavings. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
